import React from 'react';
import Text from '@lightspeed/cirrus-text';

const ReceiptAddress = ({ name, countryName, address1, address2, city, zipcode, phoneNumber }) => {
  return (
    <div className="cr-p-2">
      <Text body bold className="cr-truncate">
        <span key="name-key-for-localize">{name ? <var>{name}</var> : 'Location name'}</span>
      </Text>
      <Text body className="cr-truncate">
        <span key="address1-key-for-localize">{address1 ? <var>{address1}</var> : 'Address'}</span>
        <span key="address2-key-for-localize">{address2 ? <var>, {address2}</var> : ''}</span>
      </Text>
      <Text body className="cr-truncate">
        <span key="city-key-for-localize">{city ? <var>{city}</var> : 'City'}</span>,{' '}
        <span key="zip-key-for-localize">{zipcode ? <var>{zipcode}</var> : 'Postal code'}</span>
      </Text>
      <Text body className="cr-truncate">
        <span key="country-key-for-localize">
          {countryName ? <var>{countryName}</var> : 'Country'}
        </span>
      </Text>
      <Text body className="cr-pt-2 cr-truncate">
        <span key="phone-key-for-localize">
          {phoneNumber ? <var>{phoneNumber}</var> : '+1 (555) 555-5555'}
        </span>
      </Text>
    </div>
  );
};

export default ReceiptAddress;
